const $LpCareerSelect2 = $('.LpCareerSelect2');

$LpCareerSelect2.each(function(){
    const $el = $(this);
    $el.select2({
        language: 'cs',
        width: '100%',
        tags: false,
        //minimumResultsForSearch: 10,
        theme: 'LpCareerSelect2Js',
        allowClear: !$el.is('[multiple]')
    });
});